import React, { useEffect, useState } from "react";
import { View } from "react-native";
import StandardText from "../../sharedComponents/standardText/StandardText";
import useWamp from "../../hooks/useWamp";

export function OpenGamesActivityDisplay({ accessToken }) {
    const wamp = useWamp();

    const [activePlayersCount, setActivePlayersCount] = useState(null);
    const [activePlayersInOpenGamesCount, setActivePlayersInOpenGamesCount] = useState(null);
    const [activeOpenGamesCount, setActiveOpenGamesCount] = useState(null);

    useEffect(() => {
        if (!accessToken || !wamp) {
            return;
        }

        let mounted = true;
        const fetchCounts = () => {
            wamp.getGameActivityCounts() .then(
                (counts) => {
                    if (mounted) {
                        setActivePlayersCount(counts["activePlayersCount"]);
                        setActiveOpenGamesCount(counts["activeOpenGamesCount"]);
                        setActivePlayersInOpenGamesCount(counts["activePlayersInOpenGamesCount"]);
                    }
                },
                (err) => {
                    console.error("error fetching game activity counts", err);
                },
            );
        };
        fetchCounts();
        const interval = setInterval(fetchCounts, 10000);

        return () => {
            mounted = false;
            clearInterval(interval);
        };
    }, [accessToken, wamp]);

    return <View style={{ width: "100%", textAlign: "center" }}>
        {!!activePlayersInOpenGamesCount && !!activePlayersCount && (
            <StandardText weight={500}>{activePlayersInOpenGamesCount} out of {activePlayersCount} active player(s) currently playing an Open Game.</StandardText>
        )}

        {!activePlayersInOpenGamesCount && !!activePlayersCount && (
            <StandardText weight={500}>{activePlayersCount} active player(s).</StandardText>
        )}

        {!activePlayersInOpenGamesCount && !activePlayersCount && (
            <StandardText weight={500}>---</StandardText>
        )}
    </View>;
}